import { useLocation } from 'react-router-dom';

import ROUTE_NAMES from 'setup/Routing/routeNames';
import useFeatureFlag, { FEATURE_FLAGS } from 'utils/useFeatureFlag';
import { stripTeamPrefix } from 'utils/teamFromUrl';

/**
 * Whether the current route is in Fleet Management, which spans teams: the
 * last team viewed must not be shown there (top nav, tab title or favicon).
 */
export default function useIsManagementSection(): boolean {
  const location = useLocation();
  const enabled = useFeatureFlag(
    FEATURE_FLAGS.PD_1188_ROUTE_BASED_FLEET_MANAGEMENT,
  );

  return (
    enabled &&
    stripTeamPrefix(location.pathname).startsWith(ROUTE_NAMES.admin.management)
  );
}
